var _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSuccessCheck(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 139,
    height: 69,
    viewBox: "0 0 139 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.916 7.15804L119.472 6.85707L109.853 6.01685L108.264 8.27356L101.426 17.9937L99.7608 20.3574L98.6738 19.7054L91.132 15.1835L83.2121 19.9308L90.7625 24.6311H90.7639L94.3715 26.8764L94.9278 27.2231H94.9264L90.7596 24.6311L83.2121 19.9294L81.1308 21.1762L69.7246 28.0133L77.5232 32.8691L86.861 38.6821H86.8596L90.7611 41.1114L98.0761 45.6662H98.0775L98.524 45.6861L112.382 46.3951L138.549 8.52177L122.917 7.15518L122.916 7.15804Z",
    fill: "#002007"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M122.494 0V0.00285577L101.862 12.8498L101.14 13.2977L98.5307 14.9225L88.9546 20.8852H88.9518V20.8867L72.928 30.8607L60.5917 38.5409H60.5903L59.5361 37.0431L54.7402 30.2259L63.4875 24.9836L77.2959 16.7057L79.8137 15.195L89.4011 9.44908L102.191 1.78026L110.141 1.08272L122.494 0Z",
    fill: "#004202"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M122.494 0.00146484L124.151 18.9253L70.3561 52.415L64.5047 44.0986L60.5918 38.5424L101.14 13.2964L122.494 0.00146484Z",
    fill: "#16CB3E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.78613 15.9025L26.7099 14.2478L42.0932 38.0973L51.2741 52.338L56.779 60.867L56.2369 60.8912L39.4614 61.75L7.78613 15.9025Z",
    fill: "#DADAFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M70.3582 52.4164L56.7809 60.8683L51.2732 52.3393L42.0923 38.0987L26.709 14.2463L30.8786 13.8826L42.5231 12.8655L54.7424 30.2273L59.5368 37.0431L60.591 38.5409L64.5081 44.0971L70.3582 52.4164Z",
    fill: "#16CB3E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M73.8811 59.8572L115.018 34.2474M0.175781 21.1721L32.9979 68.68L49.5267 67.9653",
    stroke: "#002007",
    strokeWidth: 0.427947,
    strokeMiterlimit: 10
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessCheck);
export default __webpack_public_path__ + "static/media/success-check.d0d40bedb291324c77fa8cf7b091ade3.svg";
export { ForwardRef as ReactComponent };